<i class="far fa-exclamation" data-fa-symbol="exclamation-simple"></i>
<i class="far fa-times" data-fa-symbol="times"></i>

<div class="table-container">
  <div class="d-flex filters" *ngIf="typeAheadStations.filter_values.length > 0">
    <qm-filters [filterDefinitions]="trainTypeFilters"
                [typeAheadDefinitions]="typeAheadStations"
                (filtersChanged)="filtersChanged($event)"
                [placeholder]="'Choose departure station' | translate"
                [position]="'left'" style="width: 100%;">
    </qm-filters>
  </div>
  <div class="d-flex flex-row station-results" *ngIf="activeStations.length > 0">
    <div class="d-flex flex-row station" *ngFor="let single of activeStations">
      {{single.value}}
      <a (click)="removeFromActives(single)">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#times"></use>
        </svg>
      </a>
    </div>
  </div>
  <table class="table table-sm table-hover" *qmLoading="loading">
    <thead>
    <tr>
      <th [style.width]="columnWidths.train">
        {{'Train' | translate}}
      </th>
      <th [style.width]="columnWidths.status">
        &nbsp;
      </th>
      <th [style.width]="columnWidths.time">
        {{'Departure time' | translate}}
      </th>
      <th [style.width]="columnWidths.route">
        {{'Route' | translate}}
      </th>
      <th>
        {{'Status information' | translate}}
      </th>
    </tr>
    </thead>
    <tbody>
    <ng-template ngFor let-train [ngForOf]="displayedTrains | slice:0:listLimit">
      <tr [ngClass]="train.status">
        <td
          [style.width]="columnWidths.train"
          (click)="openTrainInfo(train)"
          class="clickable-text">
          <ng-container *ngIf="train.commercialId; else trainCategory;">
            {{train.commercialId + ' ' + train.tripNumber}}
          </ng-container>
          <ng-template #trainCategory>{{train.category + ' ' + train.tripNumber}}</ng-template>
        </td>
        <td [style.width]="columnWidths.status">
          <!-- ready means it has been confirmed already(?) so no need to show confirmation when it's ready -->
          <span
            *ngIf="train.confirmed && !train.ready"
            class="train-status-confirmed"
            ngbTooltip="{{'Confirmed' | translate}}"
            (click)="selectAlarmOverlayTrain(train); alarmDetails.toggle($event); $event.stopPropagation()"
          >
            <i class="fas fa-check-circle"></i>
          </span>

          <span
            *ngIf="train.ready"
            class="train-status-ready"
            ngbTooltip="{{'Ready for departure' | translate}}"
            (click)="selectAlarmOverlayTrain(train); alarmDetails.toggle($event); $event.stopPropagation()"
          >
            <i class="fas fa-check-circle"></i>
          </span>
        </td>
        <td [style.width]="columnWidths.time">
          <span>{{train.depTime | qmDateFormat:'HH:mm'}}</span>
          <span *ngIf="train.status === 'danger' || train.status === 'warning'" class="badge badge-pill"
                style="margin-left: 10px"
                [ngClass]="'badge-' + train.status">{{(currentDate$ | async) | qmDateDiff: train.depTime :'m'}}</span>
        </td>
        <td [style.width]="columnWidths.route">
          {{train.depStation}} - {{train.arrStation}}
        </td>
        <td>
          <span
            class="badge badge-warning clickable"
            *ngIf="train.vak"
            ngbTooltip="{{ 'See VAK info from cargo manifest' | translate }}"
            (click)="openCargoInfo(train)"
          >
            VAK
          </span>
          <span
            *ngFor="let cause of train.causes | qmMapValues"
            (click)="selectAlarmOverlayTrain(train); alarmDetails.toggle($event); $event.stopPropagation()"
            class="clickable"
            ngbTooltip="{{ 'Open alarm details' | translate }}"
          >
            {{ cause.val.determinedKonegisCauseCode }}
          </span>
          <span
            *ngIf="getDependencyConflictForTrain | applyFunction:train"
            (click)="openTrainInfo(train)"
            ngbTooltip="{{'Conflicts' | translate}}"
            class="clickable">
            <ng-container *ngTemplateOutlet="conflictIcon"></ng-container>
          </span>
          <span
            *ngIf="getDepartureAlarmForTrain | applyFunction:train"
            (click)="openTrainInfo(train)"
            ngbTooltip="{{'Train departure' | translate}}"
            class="clickable">
            <ng-container *ngTemplateOutlet="conflictIcon"></ng-container>
          </span>
          <ng-container *ngIf="hasActiveTechnicalAlarms | applyFunction:train">
              <qm-technical-alarm-item
                *ngFor="let alarm of getActiveTechnicalAlarms | applyFunction:train"
                mode="icon"
                [alarm]="alarm"
                ngbTooltip="{{'Technical alarm' | translate}}"
                class="clickable">
              </qm-technical-alarm-item>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <div [ngStyle]="{width: '100%', padding: '1em', textAlign: 'center'}">
      <button
        *ngIf="listLimit < displayedTrains.length"
        (click)="onLoadMoreBtnClicked()"
        class="btn btn-outline-info">
        {{ 'Load more' | translate }}
      </button>
    </div>

    </tbody>
  </table>
</div>

<qm-overlay-panel #alarmDetails [stickTo]="'left-bottom'" [appendTo]="'body'" [dismissable]="true" [skipFirstClick]="false">
    <div class="card hover-container" *ngIf="alarmOverlaySelectedTrain">
        <div class="card-header">
          <ng-container *ngIf="alarmOverlaySelectedTrain.commercialId; else trainCategory;">
            {{alarmOverlaySelectedTrain.commercialId + ' ' + alarmOverlaySelectedTrain.tripNumber}}
          </ng-container>
          <ng-template #trainCategory>{{alarmOverlaySelectedTrain.category + ' ' + alarmOverlaySelectedTrain.tripNumber}}</ng-template>
          {{ 'Status' | translate }}
        </div>
        <div class="card-body">
            <ng-container *ngIf="alarmOverlaySelectedTrain.causes && alarmOverlaySelectedTrain.causes.size > 0; else noCauseCodes;">
                <h5>{{ 'Reason code details' | translate }} </h5>
                <span *ngFor="let cause of alarmOverlaySelectedTrain.causes | qmMapValues">
                    {{ cause.val.determinedKonegisCauseCode }} {{ cause.val.liviCauseCode?.categoryName }}
                    <div class="rounded border border-danger" style="display: block; width: 4em; text-align: center">
                      <a href="http://liike/kuti/#/aikataulupoikkeamat" target="_blank" id="challenge-link">{{ 'Challenge' | translate}}</a>
                    </div>
                </span>
                <br />
            </ng-container>
          <ng-template #noCauseCodes>
            <p>{{ 'No active reason code' | translate }}</p>
          </ng-template>

      <!--<ng-container *ngIf="getDependencyConflictForTrain  | applyFunction:alarmOverlaySelectedTrain; else noConflicts">
            <h5>{{ 'Conflicts' | translate }}</h5>
            <div>
              {{ getTranslatedAlarm | applyFunction:(getDependencyConflictForTrain  | applyFunction:alarmOverlaySelectedTrain) }}
            </div>
          </ng-container>
          <ng-template #noConflicts>
              <p>{{ 'No conflicts' | translate }}</p>
          </ng-template>-->

          <ng-container *ngIf="(diffFromNow | applyFunction:alarmOverlaySelectedTrain) > 0">
            <h5>{{ 'Schedule expiration' | translate }}</h5>
            {{30 - (diffFromNow  | applyFunction:alarmOverlaySelectedTrain)}}
            {{ 'minutes' | translate }}
          </ng-container>

        </div>
    </div>
</qm-overlay-panel>

<ng-template #conflictIcon>
    <i style="color: var(--color-danger-base)" class="far fa-exclamation-triangle"></i>
</ng-template>
